import { useEffect, useRef, type ReactNode } from 'react';
import clsx from 'clsx';

interface PopoverProps {
  open: boolean;
  onClose: () => void;
  align?: 'start' | 'end';
  children: ReactNode;
}

export function Popover({ open, onClose, align = 'start', children }: PopoverProps) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    if (!open && el.open) el.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      onClose={onClose}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      className={clsx(
        'rounded-[var(--radius-lg)] border border-border-subtle bg-[var(--color-bg-elevated)] p-3',
        'shadow-[var(--shadow-3)] backdrop:bg-black/40 backdrop:backdrop-blur-sm',
        align === 'end' ? 'ml-auto mr-4' : 'mr-auto ml-4',
      )}
    >
      {children}
    </dialog>
  );
}
